<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.unknown_notes')"/>
        <div class="row">
          <external-scale-record-list
            :records="records"
            @row-clicked="editRecord"
          />
        </div>

        <!-- Editor-->
        <external-scale-record-modal
          v-if="record && isObserver"
          v-model="record"
          @cancel="record = null"
          @close-and-update="closeAndUpdate"
        />

        <div
          v-if="loading"
          id="loader"
          class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import ExternalScaleRecordList from "@/components/materials/station/ExternalScaleRecordList";
import ExternalScaleRecordModal from "@/components/materials/station/ExternalScaleRecordModal";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'ExternalScaleRecords',
    components: {
        Navbar,
        ExternalScaleRecordModal,
        ExternalScaleRecordList
    },
    mixins: [restApi],
    props: {
        isObserver: {
            type: Boolean,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            records: [],
            record: null
        }
    },
    created: function () {
        this.fetchRecords()
    },
    methods: {
        fetchRecords: function () {
            this.loading = true
            this.records = []
            this.restFetchParams(this.scaleRecordUrl, {status: 0}, this.handleResponse, this.onError)
        },
        handleResponse: function (response) {
            this.records = response.data
            this.loading = false
        },
        onError: function () {
            this.loading = false
        },
        editRecord: function (record) {
            this.record = record
        },
        closeAndUpdate: function () {
            this.record = null
            this.fetchRecords()
        }
    }
}
</script>
